import { defineMessages } from 'react-intl';

export const translations = defineMessages({
    linkMessage: {
        id: 'Footer.link.message',
        defaultMessage: 'Get to know me more, discover my profile on @welovedevs ➡️ {link}'
    }
});
